var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.faqContainer,
    attrs: {
      "data-question-block": ""
    }
  }, [_c('div', {
    class: _vm.$style.heading,
    on: {
      "click": _vm.toggleOpen
    }
  }, [_c('p', {
    staticClass: "button-text motto-blue-text"
  }, [_vm._v(_vm._s(_vm.question))]), _c('BaseIcon', {
    class: (_class = {}, _class[_vm.$style.chevronIcon] = true, _class['color-gray'] = !_vm.isOpen, _class['color-secondary-green'] = _vm.isOpen, _class),
    attrs: {
      "name": _vm.isOpen ? 'chevron-up' : 'chevron-down'
    }
  })], 1), _c('Transition', {
    attrs: {
      "name": "slide-y"
    }
  }, [_vm.isOpen ? _c('div', {
    class: _vm.$style.content
  }, [_c('p', {
    staticClass: "p1",
    domProps: {
      "innerHTML": _vm._s(_vm.answer)
    }
  }), _vm.imageUrl ? _c('img', {
    class: _vm.$style.thumbnail,
    attrs: {
      "src": _vm.imageUrl,
      "alt": "Question Image"
    }
  }) : _vm._e()]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }